import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { warehouseLocationMultiSelectorViewModel } from "../warehouseLocationSelector/warehouseLocationMultiSelector-viewModel";
import  { WarehouseLocationAssignmentView } from "./warehouseLocationAssignment-view"
import { warehouse, WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";

export class WarehouseLocationAssignmentViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تخصیص location';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.assignedLocations = ObservableArray.create<assignedLocation>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.selectedWarehouseId = w.id;
            this.selectedWarehouseName = w.title;
            this.selectedWarehouse = w;
            this.refresh();
        }

       
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseLocationAssignmentView();
    }
    public getTypeId(): string {
        return "VM-A5957935-6920-453F-9528-5A5774CD5081"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set assignedLocations(v: ObservableArray<assignedLocation>) { this._assignedLocation = v; } public get assignedLocations(): ObservableArray<assignedLocation> { return this._assignedLocation;} private _assignedLocation: ObservableArray<assignedLocation>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set selectedWarehouse(v: warehouse) { this._selectedWarehouse = v; } public get selectedWarehouse(): warehouse { return this._selectedWarehouse;} private _selectedWarehouse: warehouse;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName;} private _selectedWarehouseName: string;
    public set selectedWarehouseId(v: string) { this._selectedWarehouseId = v; } public get selectedWarehouseId(): string { return this._selectedWarehouseId;} private _selectedWarehouseId: string;
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/GetProductPlacesInWarehouse',{
                FurtherQueryInfo:filteringInformation,
                WarehouseId : this.selectedWarehouse.id
            });
            this.assignedLocations.update(...result.MeasuredProducts.map(q=>{
                let r = new assignedLocation(this);
                r.id=q.Id;
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.unitName = q.UnitName;
                r.warehouseId = this.selectedWarehouseId;
                r.warehouseName = this.selectedWarehouseName;
                r.joinWarehouseNames = q.Locations.map(w=>w.Name).join(', ');
                r.setLocationIds(q.Locations.map(w=>w.Id));
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    edit(assignedLocation:assignedLocation){
        var updater = new assignedLocationEditor(this,new UpdateServerUpdater());
        assignedLocation.cloneTo(updater);
        updater.onSuccess = ()=>this.refresh();
        this.showPopup(updater);
    }
}


export class assignedLocation extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseLocationAssignmentViewModel) {
        super(parent);
        this.locationIds = ObservableArray.create<string>();
        this._typedParent = parent;
    }
    
    public _typedParent : WarehouseLocationAssignmentViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set joinWarehouseNames(v: string) { this._joinWarehouseNames = v; } public get joinWarehouseNames(): string { return this._joinWarehouseNames;} private _joinWarehouseNames: string;
    public set locationIds(v: ObservableArray<string>) { this._locationIds = v; } public get locationIds(): ObservableArray<string> { return this._locationIds;} private _locationIds: ObservableArray<string>;
    
    clone(parent:WarehouseLocationAssignmentViewModel):assignedLocation{
        let u = new assignedLocation(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(loc:assignedLocation){
        loc.id = this.id;
        loc.measuredProductId = this.measuredProductId;
        loc.productName = this.productName;
        loc.productCode = this.productCode;
        loc.unitName = this.unitName;
        loc.warehouseName = this.warehouseName;
        loc.joinWarehouseNames = this.joinWarehouseNames;
        loc.setWarehouseId(this.warehouseId);
        loc.setLocationIds(this.getLocationIds());
    }
    getLocationIds():string[]{
        return [...this.locationIds];
    }
    setWarehouseId(warehouseId: string) {
        this.warehouseId = warehouseId;
    }
    setLocationIds(ids:string[]){
        this.locationIds.update(...ids);
    }

    edit(){
        this._typedParent.edit(this);
    }
}

interface IServerUpdate{
    execute(loc:assignedLocation):Promise<void>;
}

class UpdateServerUpdater implements IServerUpdate{
    
    async execute(loc: assignedLocation): Promise<void> {
        try {
            let result =  await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/SetProductPlacement',{
                MeasuredProduct : loc.measuredProductId,
                WarehouseParty: loc.warehouseId,
                Places:loc.getLocationIds()
            });
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}

export class assignedLocationEditor extends assignedLocation implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseLocationAssignmentViewModel,updater : IServerUpdate) {
        super(parent);
        this.updater = updater;
    }

    closePopup() {}
    onSuccess(){}

    public set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful;} private _isSuccessful: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseLocationSelector(v: warehouseLocationMultiSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationMultiSelectorViewModel { return this._warehouseLocationSelector;} private _warehouseLocationSelector: warehouseLocationMultiSelectorViewModel;
    
    private updater : IServerUpdate;

    save(){
        try {
            this.isLoading = true;
            this.updater.execute(this);
            this.joinWarehouseNames = this.warehouseLocationSelector.selectedItems.map(x=>x.title).join(', ');
            this.isSuccessful = true;            
        } catch (ex) {
            console.log(ex);
            this.isFailed = true;
        } finally {
            this.isLoading = false;
        }
    }

    closeSuccess(){
        this.onSuccess();
        this.closePopup();
    }
    closeFailed(){
        this.isFailed = false;
    }
    setWarehouseId(warehouseId: string) {
        this.warehouseId = warehouseId;
        this.warehouseLocationSelector = new warehouseLocationMultiSelectorViewModel(this,warehouseId);
    }
    setLocationIds(ids:string[]){
        this.locationIds.update(...ids);
        this.warehouseLocationSelector.selectById(this.locationIds)
    }
    getLocationIds():string[]{
        return this.warehouseLocationSelector.selectedItems.map(x=>x.id);
    }
}